<template>
  <div class="container-lg clearfix px-2">
    <div v-if="hasMessages()">
      <div v-for="value in flash" :key="value" v-bind:class="flashClass">
        <button v-on:click="clearFlash" class="flash-close js-flash-close" type="button">
          <svg width="12" height="16" viewBox="0 0 12 16" class="octicon octicon-x" aria-label="Close" role="img">
            <path
              fill-rule="evenodd"
              d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48L7.48 8z"
            />
          </svg>
        </button>
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flash: {
      type: Object,
      required: true
    }
  },
  computed: {
    flashClass: function() {
      if('error' in this.flash) {
        return "flash-error flash m-2"
      } else if('success' in this.flash) {
        return "flash-success flash m-2"
      } else {
        return "flash-wtf flash m-2"
      }
    },
  },
  methods: {
    hasMessages: function() {
      return Object.keys(this.flash).length > 0;
    },
    clearFlash: function() {
      this.$store.dispatch("setFlash", {});
    }
  }
};
</script>

<style>
ul {
  list-style: none;
}
</style>
